import { render } from "./MagicInput.vue?vue&type=template&id=11dd9fc5"
import script from "./MagicInput.vue?vue&type=script&lang=js"
export * from "./MagicInput.vue?vue&type=script&lang=js"

import "./MagicInput.vue?vue&type=style&index=0&id=11dd9fc5&lang=less"
script.render = render

export default script